import React from "react";
import { pricingCompare, pricingFeatures } from "../data/siteData";
import { Link } from "react-scroll";

function PricingSection() {
  return (
    <section id="pricing" className="section section--alt pricing">
      <div className="pricing__head">
        <p className="eyebrow center">Pricing</p>
        <h2 className="center">One plan. Everything included.</h2>
        <p className="center">
          No hidden fees. No per-module charges. No surprises at the end of the
          year.
        </p>
      </div>
      <div className="pricing__cards">
        <article className="pricing__card pricing__card--featured">
          <span className="pricing__badge pricing__badge--dark">byond care</span>
          <h3 className="pricing__amount">RM 200</h3>
          <p className="pricing__period">per month · billed annually at RM 2,400</p>
          <ul>
            {pricingFeatures.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <div className="pricing__cta">
            <Link to="demo" smooth duration={450} offset={-70} className="btn">
              Book a Demo
            </Link>
          </div>
        </article>
        <article className="pricing__card">
          <span className="pricing__badge">Subscriber add-on</span>
          <h3>KiraOS accounting</h3>
          <h4 className="pricing__amount pricing__amount--small">RM 1,200</h4>
          <p className="pricing__period">per year · 50% off standard price</p>
          <ul>
            <li>AI-native accounting ERP</li>
            <li>Automated invoicing</li>
            <li>Multi-entity financial reporting</li>
            <li>LHDN financial compliance</li>
            <li>Exclusive to byond care subscribers</li>
          </ul>
        </article>
      </div>
      <div className="pricing__compare compare-wrap">
        <h3 className="center">See what&apos;s really included.</h3>
        <table className="compare-table">
          <thead>
            <tr>
              <th>Feature</th>
              <th className="compare-table__byond">byond care</th>
              <th>Typical clinic CMS</th>
            </tr>
          </thead>
          <tbody>
            {pricingCompare.map(([feature, byond, typical]) => (
              <tr key={feature}>
                <td>{feature}</td>
                <td className="compare-table__ok">{`✓ ${byond}`}</td>
                <td className="compare-table__dim">{typical}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default PricingSection;
